import type { LinkProps } from '../Link'

export default (config: { props: Pick<LinkProps, 'isLightText' | 'kind'> }) => {
  const { props } = config
  return {
    default: {
      link: {
        ...(props.isLightText && { color: '#4186ec' }),

        ...(props.kind === 'subtle' && {
          '&:hover': {
            color: '#3d3d3d',
          },

          '&:active': {
            color: '#3d3d3d',
          },

          '&:focus': {
            color: '#3d3d3d',
          },
        }),
      },
    },
  } as const
}
